module.exports = function () { return false }



//////////////////
// WEBPACK FOOTER
// ./~/empty-functions/returns-false.js
// module id = 22
// module chunks = 0